// src/pages/Careers/components/ResumeCTA.jsx
import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";

const ResumeCTA = ({ onOpenResumeModal }) => {
  return (
    <section className="py-10 md:py-12 bg-white text-gray-900 font-sans relative border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="p-8 md:p-12 rounded-xl bg-gray-900 text-white flex flex-col md:flex-row items-center justify-between gap-8 shadow-xl relative overflow-hidden"
        >
          {/* Left Text */}
          <div className="max-w-xl text-center md:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-gray-800 text-gray-200 mb-3">
              <Sparkles className="w-3.5 h-3.5" />
              Open Spontaneous Application
            </span>
            <h3 className="text-2xl md:text-4xl font-light text-white mb-3 tracking-tight">
              Don't See Your Role?
            </h3>
            <p className="text-gray-300 text-base leading-relaxed font-normal">
              We're always interested in meeting talented people who want to build, learn and grow with us.
            </p>
          </div>

          {/* Right Action Button */}
          <div className="shrink-0">
            <button
              onClick={onOpenResumeModal}
              className="px-6 py-3 rounded-lg font-medium bg-white text-gray-900 hover:bg-gray-100 transition duration-300 shadow-md flex items-center gap-2 group text-sm md:text-base"
            >
              <span>Send Your Resume</span>
              <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform text-gray-900" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ResumeCTA;
